import { Link } from "react-router";
import ListingResult from "./quick-suggest/listing-result";
import LocationResult from "./quick-suggest/location-result";
import React from "react";
import Results from "./quick-suggest/results";

export default class QuickSearchResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = { results: props.results };
  }

  locationResults = (currentRegion) => {
    if (this.props.results.locations) {
      return this.props.results.locations.map(function (result, index) {
        return (
          <LocationResult item={result} key={index} region={currentRegion} />
        );
      });
    }
  };

  listingResults = (isSale) => {
    let data = isSale ? this.props.results.sales : this.props.results.rentals;
    if (data) {
      return data.map(function (result, index) {
        return <ListingResult item={result} key={index} />;
      });
    }
  };

  close = (e) => {
    this.props.close();
    e.preventDefault();
  };

  render() {
    if (!Object.keys(this.props.results).length) {
      return null;
    }
    if (
      this.props.results.locationTotalCount +
        this.props.results.saleTotalCount +
        this.props.results.rentalTotalCount ===
      0
    ) {
      return (
        <div className="auto-complete">
          <div className="search-suggest-auto-complete bright">
            <div className="search-suggest-auto-complete-inner container">
              <div className="search-auto-complete-topper row ">
                <div className="col-xs-16">
                  <p className="error">
                    We could not find a match for your Quick Search entry:{" "}
                    <strong>{this.props.results.term}</strong>
                  </p>
                  <hr />
                  <br />
                  <p>Please try your search again!</p>
                </div>
                <a className="close-x" href="#" onClick={this.close}>
                  x
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }
    let currentRegion = "";
    if (this.props.region && this.props.region.length > 0) {
      currentRegion = "/" + this.props.region;
    }
    return (
      <div className="auto-complete">
        <div className="search-suggest-auto-complete bright">
          <div className="search-suggest-auto-complete-inner container">
            <a className="close-x" href="#" onClick={this.close}>
              x
            </a>
            <div className="search-auto-complete-topper row hidden-xs">
              <div className="col-xs-10">
                {this.props.results.locationTotalCount +
                  this.props.results.saleTotalCount +
                  this.props.results.rentalTotalCount}{" "}
                matches found, showing {this.props.results.currentCount}
              </div>
              <div className="col-xs-6">
                <Link
                  to={
                    currentRegion +
                    "/quicksearch/search/" +
                    this.props.results.term
                  }
                  id="see-all-search-matches"
                  className="highlight"
                >
                  See all matches
                </Link>
              </div>
            </div>
            <div className="row search-auto-complete-body">
              <div className="col-xs-16">
                <div className="search-matches">
                  <Results
                    resultClass="location-matches"
                    title="Places"
                    items={this.locationResults(currentRegion)}
                  />
                  <Results
                    resultClass="sale-matches"
                    title="Sale Listings"
                    items={this.listingResults(true)}
                    seeAllUrl={
                      currentRegion +
                      "/quicksearch/sales/" +
                      this.props.results.term
                    }
                    seeAllContent={
                      this.props.results.saleTotalCount > 1
                        ? "See all " +
                          this.props.results.saleTotalCount +
                          " sale listings"
                        : null
                    }
                  />
                  <Results
                    resultClass="rental-matches"
                    title="Rental Listings"
                    items={this.listingResults(false)}
                    seeAllUrl={
                      currentRegion +
                      "/quicksearch/rentals/" +
                      this.props.results.term
                    }
                    seeAllContent={
                      this.props.results.rentalTotalCount > 1
                        ? "See all " +
                          this.props.results.rentalTotalCount +
                          " rental listings"
                        : null
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/search-widget/quick-search-results.js